import React, { Dispatch, SetStateAction } from 'react'

import Filter from '../Filter'
import FilterCategory from '../FilterCategory';
import Order from '../Order';

import { Container } from './styles'

interface IFilterState {
    env: string;
    search: string;
    priceRange: number[];
    size: string;
}

interface ICategorysState {
    search: string;
    category: string;
    brands: string;
}

interface IOrder {
    order: string;
}

interface ISettingsContainerProps {
    filterConfigs: {
        shouldHide: boolean;
        filterName: string;
        filterTitle: string;
        filterType: 'radio' | any;
        filterItems?: {
            filterItemName: string;
            filterItemValue: string | number[];
            id?: number;
        }[];
        isOpen: boolean;
    }[];
    filterConfigsCategory: {
        shouldHide: boolean;
        filterName: string;
        filterTitle: string;
        filterType: 'radio' | any;
        filterItems?: {
            filterItemName: string;
            filterItemValue: string | number[];
        }[];
        isOpen: boolean;
    }[];
    orderConfigs: {
        itemName: string;
        itemValue: string;
        key: string;
    }[]
    onClearPage: () => void;
    onClick: (key: string) => void;
    onCloseModal: (key: string) => void;
    isOpen: {
        filter: boolean;
        order: boolean;
        category: boolean;
    };
    filter: IFilterState;
    setFilter: Dispatch<SetStateAction<IFilterState>>;
    setFilterCategorys: Dispatch<SetStateAction<ICategorysState>>;
    onChangeFilterStatesHandler: (filterKey: string) => void;
    order: IOrder;
    onClearFilter: () => void;
    onClearCategory: () => void;
    activeFiltersCount: number;
    activeCategoryCount: number;
    classNameFilter?: string;
    classNameOrder?: string;
    shouldUseArrow?: boolean;
    className: string;
    onOrderHandler: (key: string, value: string) => void;
}

const brandsWithCategorys = ['lojaoffpremium', 'lojafarm', 'mariafilo', 'lojacrisbarros'];
const SettingsContainer: React.FC<ISettingsContainerProps> = ({
    activeFiltersCount,
    activeCategoryCount,
    filterConfigs,
    orderConfigs,
    filterConfigsCategory,
    isOpen,
    onClearFilter,
    onClearCategory,
    onClearPage,
    onClick,
    onCloseModal,
    filter,
    setFilter,
    setFilterCategorys,
    onChangeFilterStatesHandler,
    classNameOrder,
    shouldUseArrow,
    className,
    order,
    onOrderHandler,
}) =>

    <Container className={className}>
        {
            brandsWithCategorys.includes(filter.env) ?
                <FilterCategory
                    filterConfigsCategory={filterConfigsCategory}
                    isOpen={isOpen.category}
                    onCloseModal={() => onCloseModal('category')}
                    onClick={() => onClick('category')}
                    setFilter={setFilterCategorys}
                    onClearPage={onClearPage}
                    onClearFilter={onClearCategory}
                    onChangeFilterStatesHandler={onChangeFilterStatesHandler}
                    activeCategoryCount={activeCategoryCount}
                    className={'settings--container category'}
                    shouldUseArrow={shouldUseArrow}>
                    Categorias
                </FilterCategory>
                : null
        }

        <Filter
            filterConfigs={filterConfigs}
            isOpen={isOpen.filter}
            onCloseModal={() => onCloseModal('filter')}
            onClick={() => onClick('filter')}
            setFilter={setFilter}
            onClearPage={onClearPage}
            onClearFilter={onClearFilter}
            onChangeFilterStatesHandler={onChangeFilterStatesHandler}
            activeFiltersCount={activeFiltersCount}
            filter={filter}
            className={className}
            shouldUseArrow={shouldUseArrow}>
            Filtrar
        </Filter>

        <Order
            isOpen={isOpen.order}
            shouldUseArrow={shouldUseArrow}
            onClick={() => onClick('order')}
            onOrderHandler={onOrderHandler}
            orderConfigs={orderConfigs}
            onClose={() => onCloseModal('order')}
            order={order}
            className={classNameOrder}
        />
    </Container>

export default SettingsContainer